import { render } from "./creditors-receipt.vue?vue&type=template&id=4552e1ee&scoped=true"
import script from "./creditors-receipt.vue?vue&type=script&lang=js"
export * from "./creditors-receipt.vue?vue&type=script&lang=js"

import "./creditors-receipt.vue?vue&type=style&index=0&id=4552e1ee&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\bmac\\ims-web-api\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4552e1ee"]])

export default __exports__